import { DEFAULT_PALETTE } from '../../core/palette';
import type { ParamSchema, SchemaValues } from '../../core/params/types';

export const SOFT_BODY_PARAMS = [
  {
    kind: 'float',
    key: 'meshSpacing',
    label: 'Massepunkt-Abstand',
    min: 4,
    max: 60,
    step: 0.5,
    scale: 'log',
    default: 14,
    unit: 'px',
    bulkRange: [8, 30],
    group: 'Netz',
    tooltip: 'Dichter heisst weicher und teurer.',
  },
  {
    kind: 'float',
    key: 'stiffness',
    label: 'Federsteifigkeit',
    min: 0.02,
    max: 1,
    step: 0.01,
    default: 0.42,
    group: 'Netz',
  },
  {
    kind: 'int',
    key: 'iterations',
    label: 'Lösungsdurchgänge',
    min: 1,
    max: 20,
    step: 1,
    default: 5,
    group: 'Netz',
    tooltip: 'Mehr Durchgänge lassen das Netz steifer wirken.',
  },
  {
    kind: 'enum',
    key: 'anchors',
    label: 'Fixpunkte',
    default: 'top',
    group: 'Netz',
    options: [
      { value: 'none', label: 'Keine' },
      { value: 'top', label: 'Oben' },
      { value: 'bottom', label: 'Unten' },
      { value: 'corners', label: 'Ecken' },
      { value: 'sides', label: 'Seiten' },
    ],
  },

  {
    kind: 'float',
    key: 'gravity',
    label: 'Schwerkraft',
    min: -1,
    max: 1.5,
    step: 0.01,
    default: 0.28,
    group: 'Kräfte',
  },
  {
    kind: 'float',
    key: 'damping',
    label: 'Dämpfung',
    min: 0,
    max: 0.3,
    step: 0.005,
    default: 0.03,
    group: 'Kräfte',
  },
  {
    kind: 'float',
    key: 'wind',
    label: 'Wind',
    min: 0,
    max: 3,
    step: 0.01,
    default: 0.35,
    group: 'Kräfte',
  },
  {
    kind: 'float',
    key: 'windFrequency',
    label: 'Windfrequenz',
    min: 0.05,
    max: 4,
    step: 0.05,
    default: 0.7,
    group: 'Kräfte',
    showIf: (v) => (v.wind as number) > 0,
  },
  {
    kind: 'int',
    key: 'steps',
    label: 'Standbild nach',
    min: 1,
    max: 900,
    step: 1,
    default: 120,
    unit: 'Schr.',
    bulkRange: [20, 400],
    group: 'Kräfte',
  },

  {
    kind: 'enum',
    key: 'style',
    label: 'Darstellung',
    default: 'mesh',
    segmented: true,
    group: 'Darstellung',
    options: [
      { value: 'mesh', label: 'Netz' },
      { value: 'points', label: 'Punkte' },
      { value: 'blob', label: 'Fläche' },
    ],
  },
  {
    kind: 'float',
    key: 'lineWidth',
    label: 'Strichstärke',
    min: 0.2,
    max: 8,
    step: 0.1,
    default: 0.9,
    unit: 'px',
    group: 'Darstellung',
  },
  {
    kind: 'float',
    key: 'opacity',
    label: 'Deckkraft',
    min: 0.05,
    max: 1,
    step: 0.01,
    default: 0.8,
    group: 'Darstellung',
  },

  {
    kind: 'enum',
    key: 'colorMode',
    label: 'Farbmodus',
    default: 'stretch',
    group: 'Farbe',
    options: [
      { value: 'solid', label: 'Einfarbig' },
      { value: 'stretch', label: 'Nach Dehnung' },
      { value: 'height', label: 'Nach Höhe' },
    ],
  },
  {
    kind: 'palette',
    key: 'palette',
    label: 'Palette',
    default: { ...DEFAULT_PALETTE, paletteId: 'ink' },
    group: 'Farbe',
  },
] as const satisfies ParamSchema;

export type SoftBodyValues = SchemaValues<typeof SOFT_BODY_PARAMS>;
